import React from 'react'
import {observer} from "mobx-react"

import {AntSelect, AntSelectPropsGeneric} from "controls/react/ant/antSelect"
import {getAccountsLite} from "areas/administration/accounts/api"
import {useRemoteListForSelect} from "framework/api";
import {Account} from "controls/accountSelector";

const i = require('core/localization/localization').translator({
	'Select an Account...': {
		no: 'Du mÃ¥ legge til en konto...'
	}
});

export type AccountSelectorProps = AntSelectPropsGeneric<string> & {
	accountId?: string
	hidePlaceholder?: boolean
	additionalOptions?: Account[]
}

export const AccountSelector = observer((props: AccountSelectorProps) => {
	const {accountId, hidePlaceholder, additionalOptions, ...rest} = props
	const remoteData = useRemoteListForSelect(getAccountsLite({accountId}), {additionalOptions})

	return <AntSelect placeholder={hidePlaceholder == true ? null : i('Select an Account...')}
					  nameField={'name'}
					  valueField={'id'}
					  {...remoteData}
	                  {...rest} />
})

export type AccountsSelectorProps = AntSelectPropsGeneric<string[]> & {
	accountId?: string
	hidePlaceholder?: boolean
}

export const AccountsSelector = observer((props: AccountsSelectorProps) => {
	const {hidePlaceholder, mode, accountId, ...rest} = props
	const remoteData = useRemoteListForSelect(getAccountsLite({accountId}))
	const innerMode = mode === undefined ? 'multiple' : mode;

	return <AntSelect mode={innerMode}
	                  placeholder={hidePlaceholder == true ? null : i('Select an Account...')}
					  nameField={'name'}
					  valueField={'id'}
					  {...remoteData}
	                  {...rest}/>
})
